import { render, staticRenderFns } from "./fileInput.vue?vue&type=template&id=c2b2b6f2&scoped=true"
import script from "./fileInput.vue?vue&type=script&lang=js"
export * from "./fileInput.vue?vue&type=script&lang=js"
import style0 from "./fileInput.vue?vue&type=style&index=0&id=c2b2b6f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b2b6f2",
  null
  
)

export default component.exports